import { httpClient } from './httpClient';

const base = '/api/pago-conceptos';

export const listarConceptos = () => httpClient.get(base);
